import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./CSS/tailwind.css";
import Signup from "./Pages/signup";
import Login from "./Pages/login";
import Sheets from "./Pages/sheets";
import Stats from "./Pages/stats";
import PlatformAnalyticsLanding from "./Pages/PlatformAnalyticsLanding";
import HowToUseSocialMediaAnalytics from "./Pages/HowToUseSocialMediaAnalytics";
import EditorPortfolio from "./Pages/editorPortfolio";
import CreatorPortfolio from "./Pages/creatorPortfolio";
import CreatorTools from "./Pages/creatorTools";
import ViewAvailableCreators from "./Pages/viewAvailableCreators";
import ResetPassword from "./Pages/resetPassword";
import ChatDetail from "./Pages/ChatDetail";
import GameOfChoice from "./Pages/gameOfChoice";
import ChatPage from "./Pages/ChatPage";
import Main from "./Pages/main";
import { AuthProvider } from "./Context/AuthContext";
import OrderDisplay from "./Pages/OrderDisplay";
import CreateNewCategory from "./Pages/CreateNewCategory";
import Orders from "./Pages/Orders";
import ViewCreatorProfile from "./Pages/viewCreatorProfile";
import ViewEditorProfile from "./Pages/viewEditorProfile";
import useNotificationPermission from "./hooks/useNotificationPermission";
import Cookies from "./T&C/cookies";
import Terms from "./T&C/terms";
import Privacy from "./T&C/privacy";
import Refund from "./T&C/refund";
import Settings from "./Pages/settings";
import EditorsPerGame from "./Pages/editorsPerGame";
import InvalidRoute from "./Pages/invalidRoute";
import Return from "./Pages/return";
import Refresh from "./Pages/refresh";
import Redeem from "./Pages/Redeem";
import Faq from "./Pages/faq";
import Onboarding from "./Pages/onboarding";
import Pricing from "./Pages/pricing.jsx";
import ForEditors from "./Pages/ForEditors.tsx";
import ForCreators from "./Pages/ForCreators";
import StreamerEditor from "./Pages/StreamerEditor";
import ClippingCampaigns from "./Pages/ClippingCampaigns";
import ForClippers from "./Pages/ForClippers";
import LaunchClippingCampaign from "./Pages/LaunchClippingCampaign";
import {
  CampaignAdminPage,
  CampaignCreationFlow,
  CampaignDetailPage,
  CampaignJoinPage,
  CampaignPayoutsPage,
  CampaignReviewPage,
  ClipSubmissionFlow,
  ClippingCampaignDashboard,
  ClippingCampaignDiscoverPage,
} from "./Pages/ClippingCampaignFlow";

export default function App() {
  useNotificationPermission();
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/stats" replace />} />
          <Route path="/home" element={<Main />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/chat/:conversationId" element={<ChatDetail />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/games" element={<Navigate to="/gaming-video-editors" replace />} />
          <Route path="/gaming-video-editors" element={<GameOfChoice />} />
          <Route path="/refresh" element={<Refresh />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="/return" element={<Return />} />
          <Route path="/creators" element={<ViewAvailableCreators />} />
          <Route path="/order/:orderNumber" element={<OrderDisplay />} />
          <Route path="/creatorPortfolio" element={<CreatorPortfolio />} />
          <Route path="/creator-tools" element={<CreatorTools />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/tiktok-analytics" element={<PlatformAnalyticsLanding platform="tiktok" />} />
          <Route path="/instagram-reels-analytics" element={<PlatformAnalyticsLanding platform="instagram" />} />
          <Route path="/twitch-stream-analytics" element={<PlatformAnalyticsLanding platform="twitch" />} />
          <Route path="/how-to-use-social-media-analytics" element={<HowToUseSocialMediaAnalytics />} />
          <Route path="/editorPortfolio" element={<EditorPortfolio />} />
          <Route path="/createCategory" element={<CreateNewCategory />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/creator/:creatorId" element={<ViewCreatorProfile />} />
          <Route path="/editor/:editorId" element={<ViewEditorProfile />} />
          <Route path="/legal/cookies" element={<Cookies />} />
          <Route path="/legal/terms" element={<Terms />} />
          <Route path="/legal/policy" element={<Privacy />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/refund" element={<Refund />} />
          <Route path="/editors" element={<Navigate to="/gaming-video-editors" replace />} />
          <Route path="/twitch-editors" element={<Navigate to="/gaming-video-editors" replace />} />
          <Route path="/stream-editor" element={<Navigate to="/hire-video-editor-for-twitch" replace />} />
          <Route path="/twitch-vod-editor" element={<Navigate to="/hire-video-editor-for-twitch" replace />} />
          <Route path="/streamer-editor" element={<StreamerEditor />} />
          <Route path="/editors/:gameId" element={<EditorsPerGame />} />
          <Route path="/rewards" element={<Redeem />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/for-creators" element={<Navigate to="/hire-video-editor-for-twitch" replace />} />
          <Route path="/hire-video-editor-for-twitch" element={<ForCreators />} />
          <Route path="/for-editors" element={<ForEditors />} />
          <Route path="/for-clippers" element={<ForClippers />} />
          <Route path="/clipping-campaigns" element={<ClippingCampaigns />} />
          <Route path="/clipping-campaigns/discover" element={<ClippingCampaignDiscoverPage />} />
          <Route path="/clipping-campaigns/admin" element={<CampaignAdminPage />} />
          <Route path="/clipping-campaigns/dashboard" element={<ClippingCampaignDashboard />} />
          <Route path="/clipping-campaigns/new" element={<CampaignCreationFlow />} />
          <Route path="/clipping-campaigns/payouts" element={<CampaignPayoutsPage />} />
          <Route path="/clipping-campaigns/:campaignId/edit" element={<CampaignCreationFlow />} />
          <Route path="/clipping-campaigns/:campaignId/join" element={<CampaignJoinPage />} />
          <Route path="/clipping-campaigns/:campaignId/submit" element={<ClipSubmissionFlow />} />
          <Route path="/clipping-campaigns/:campaignId/review" element={<CampaignReviewPage />} />
          <Route path="/clipping-campaigns/:campaignId" element={<CampaignDetailPage />} />
          <Route path="/launch-clipping-campaign" element={<LaunchClippingCampaign />} />
          <Route path="/sheets" element={<Sheets />} />
          <Route path="*" element={<InvalidRoute />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
